import { ValidationIcon } from 'src/shared/icons/Icons'
import styled from 'styled-components'

export const ValidationIconStyled = styled(ValidationIcon)<{ $valid?: boolean }>`
  color: ${({ $valid, theme }) => ($valid ? theme.colors.secondary.main : theme.colors.grey.inactive)};
`
